module.exports = __webpack_public_path__ + "img/1.5ff63506.png";